/**
 * @file
 * Announcement Banner BG Color script.
 */

export default (Drupal, once) => {
  let footerContentArea, firstComponent, elementStyles, firstComponentBGColor, announcementWrapper;

  function init(el) {
    announcementWrapper = document.querySelector(".full-width-announcement__wrapper");
    footerContentArea = document.querySelector(".onecol-100__footer");
    // Get the first component inside the flexible content area. 
    // This will be the component that controls what the background color of 
    // the announcement banner is.
    firstComponent = footerContentArea.firstElementChild;
    elementStyles = getComputedStyle(firstComponent);
    firstComponentBGColor = elementStyles.backgroundColor;
    announcementWrapper.style.backgroundColor = firstComponentBGColor;
  }

  Drupal.behaviors.announcementBannerBackground = {
    attach(context) {
      once("announcementBannerBackground", ".cics-homepage .onecol-100__content", context).forEach(init);
    },
  };
};